import api from './api'
import type { Client, ClientUser, IoTStatus, SyncDevicesResult } from '../types/client'

export const clientApi = {
  // Clients CRUD
  getClients: () => api.get<Client[]>('/clients').then((r) => r.data),
  getClient: (id: string) => api.get<Client>(`/clients/${id}`).then((r) => r.data),
  createClient: (data: Partial<Client>) => api.post<Client>('/clients', data).then((r) => r.data),
  updateClient: (id: string, data: Partial<Client>) =>
    api.patch<Client>(`/clients/${id}`, data).then((r) => r.data),
  deleteClient: (id: string) => api.delete(`/clients/${id}`),

  // IoT
  getIoTStatus: (id: string) =>
    api.get<IoTStatus>(`/clients/${id}/iot-status`).then((r) => r.data),
  syncDevices: (id: string) =>
    api.post<SyncDevicesResult>(`/clients/${id}/sync-devices`).then((r) => r.data),

  // Users
  getClientUsers: (id: string) =>
    api.get<ClientUser[]>(`/clients/${id}/users`).then((r) => r.data),
  createClientUser: (id: string, data: { email: string; first_name: string; last_name: string }) =>
    api.post<ClientUser>(`/clients/${id}/users`, data).then((r) => r.data),
  updateClientUser: (id: string, uid: string, data: Partial<ClientUser>) =>
    api.patch<ClientUser>(`/clients/${id}/users/${uid}`, data).then((r) => r.data),
  deleteClientUser: (id: string, uid: string) => api.delete(`/clients/${id}/users/${uid}`),

  // User groups
  getUserGroups: (id: string, uid: string) =>
    api.get<string[]>(`/clients/${id}/users/${uid}/groups`).then((r) => r.data),
  setUserGroups: (id: string, uid: string, groupIds: string[]) =>
    api.put(`/clients/${id}/users/${uid}/groups`, { group_ids: groupIds }),
}
